import Chart from 'chart.js'
import dateFns from 'date-fns'

export default class AnnualTargetChart {
  constructor() {
    const ctx = document.getElementById('annual-target-chart').getContext('2d')
    this.chartLine = new Chart(ctx, {
      type: 'line',
      data: {
        labels: [],
        datasets: [
          {
            type: 'line',
            data: [],
            backgroundColor: 'rgba(42, 10, 78, 0)',
            borderColor: 'rgba(42, 10, 78, 0.6)',
            borderWidth: 2,
            borderDash: [2],
            fill: 1,
            pointBorderColor: 'rgba(42, 10, 78, 1)',
            pointBackgroundColor: 'rgba(42, 10, 78, 1)',
            pointRadius: 5,
            pointBorderWidth: 2,
            // cubicInterpolationMode: 'monotone',
            lineTension: 0.33,
            spanGaps: true,
            yAxisID: 'fum',
            xAxisID: 'xFum'
          },
          {
            type: 'line',
            data: [],
            backgroundColor: 'rgba(42, 10, 78, 0)',
            borderColor: 'rgba(42, 10, 78, 1.0)',
            borderWidth: 2,
            fill: 0,
            pointBorderColor: 'rgba(42, 10, 78, 1.0)',
            pointBackgroundColor: 'rgba(255,255,255,1)',
            pointHoverBackgroundColor: 'rgba(255,255,255,1)',
            pointRadius: 5,
            pointBorderWidth: 2,
            cubicInterpolationMode: 'monotone',
            spanGaps: true,
            yAxisID: 'fum',
            xAxisID: 'xFum'
          },
          // {
          //   type: 'bubble',
          //   data: [],
          //   backgroundColor: 'rgba(42, 10, 78, 0.8)',
          //   borderColor: 'rgba(42, 10, 78, 1)',
          //   borderWidth: 2,
          //   fill: 0,
          //   yAxisID: 'clients'
          // }
        ]
      },
      options: {
        legend: { display: false },
        tooltips: {
          enabled: false,
          callbacks: { label: tooltipsCallback },
          custom: setToolTip
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              id: 'fum',
              ticks: {
                beginAtZero: true,
                callback: ticksCallback,
                padding: 10,
                fontFamily: "'pitch-sans-web-regular'"
              },
              gridLines: { drawBorder: false }
            },
            {
              id: 'clients',
              position: 'right',
              display: false,
              ticks: {
                beginAtZero: true,
                max: 500
              }
            }
          ],
          xAxes: [
            {
              id: 'xFum',
              barThickness: 5,
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: { padding: 20 }
            }
          ]
        }
      }
    })
  }

  updateAnnualTargetData(data, portfoliodata = []) {
    const dataset = data.map(x => {
      if (x.holdings === '') {
        return { holding: NaN }
      } else {
        return { holding: x.holdings }
      }
    })
    this.chartLine.data.datasets[1].data = dataset.map(x => x.holding)
    const labels = data.map(x => x.month)
    const bodyClass = document.querySelector('body').classList
    if (bodyClass.contains('firms')) {
      const targets = data.map(x => {
        if (x.target === '') {
          return NaN
        } else {
          return x.target
        }
      })
      this.chartLine.data.datasets[0].data = targets
    } else {
      this.chartLine.data.datasets[0].data = []
    }

    // const newClients = data.map((x, i) => {
    //   if (i === 0) {
    //     return 0
    //   } else {
    //     let newClient = x.new_clients - data[i - 1].new_clients
    //     if (x.new_clients - data[i - 1].new_clients < 0) {
    //       newClient = 0
    //     }
    //     return newClient
    //   }
    // })
    // this.chartLine.data.datasets[2].data = newClients
    // this.chartLine.options.scales.yAxes[
    //   this.chartLine.options.scales.yAxes.map(x => x.id).indexOf('clients')
    // ].ticks.max = newClients.reduce((max, cur) => Math.max(max, cur)) * 4
    this.chartLine.data.labels = labels
    this.chartLine.update()
  }
}

const ticksCallback = (value, index, values) => {
  return '$' + Math.round(value / 1000000, 0) + 'M'
}

const tooltipsCallback = (tooltipItem, data) => {
  const index =
    tooltipItem.datasetIndex === undefined
      ? tooltipItem.index
      : tooltipItem.datasetIndex
  const itemData = data.datasets[index]
  // Return custom data to tooltip, these will be available inside the tooltip.body
  return {
    id: data.id,
    // pictureUrl: itemData.pictureUrl,
    datasetIndex: tooltipItem.datasetIndex,
    label: itemData.label,
    value: tooltipItem.yLabel,
    xLabel: tooltipItem.xLabel,
    percent: data.percent
  }
}

const setToolTip = tooltip => {
  // Tooltip Element
  const tooltipEl = document.getElementById(
    'annual-target-chart-chartjs-tooltip'
  )

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform')
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign)
  } else {
    tooltipEl.classList.add('no-transform')
  }

  function getBody(bodyItem) {
    return bodyItem.lines
  }

  // Set Text
  if (tooltip.body) {
    var bodyLines = tooltip.body.map(getBody)

    let date = new Date(tooltip.title[0])

    let innerHtml = `<div>\
      <div class="tooltip__body">`
    bodyLines.forEach((body, i) => {
      if (body[0].datasetIndex === 0) {
        innerHtml += `<div class="caret tooltip__body--text tooltip__grey"><span>Target</span>`
      } else {
        innerHtml += `<div class="tooltip__body--text tooltip__top">`
      }
      if (body[0].datasetIndex === 2) {
        innerHtml += `New clients: ${Number(body[0].value)}</div>`
      } else {
        innerHtml += `$${Number(body[0].value).toLocaleString(undefined, {
          maximumFractionDigits: 0
        })}</div>`
      }
    })

    innerHtml += `</div>`
    bodyLines.forEach((body, i) => {
      if (body[0].datasetIndex !== 2) {
        innerHtml += `<div class="tooltip__body--date">${dateFns.format(
          date,
          'MM/YY'
        )}</div>`
      }
    })
    innerHtml += `</div>`
    // var tableRoot = tooltipEl.querySelector('.chartjs-tooltip')
    tooltipEl.innerHTML = innerHtml
  }

  const chart = document.getElementById('annual-target-chart')
  let height = chart.style.height.slice(0, chart.style.height.indexOf('px'))
  height = height - 20
  if (window.innerWidth < 960) {
    height = height - 55
  }

  if (tooltip.body[0].lines[0].datasetIndex === 2) {
    height = tooltip.caretY + 25
  }
  // adjusting for ticks padding
  tooltipEl.style.opacity = 1
  tooltipEl.style.position = 'absolute'
  tooltipEl.style.left = tooltip.caretX + 'px'
  tooltipEl.style.top = tooltip.caretY + 'px'
  tooltipEl.style.height = height - tooltip.caretY + 'px'
  tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px'
}



// WEBPACK FOOTER //
// ./assets/j/src/charts/annual_target.js